/**
 * _visible_area.js — pin a full-screen chat sheet to the part of the screen the user can see.
 *
 * The phone chat sheet (public_chat.css, "Mobile: full-height sheet") is a
 * position:fixed box. iOS (Safari, the home-screen PWA and the WKWebView shell)
 * never resizes the layout viewport for the on-screen keyboard: it shrinks only
 * the visual viewport and scrolls the page to reveal the focused input, which
 * pushes the sheet's header off the top. Android shells and Chrome resize
 * differently again. Sizing the sheet from visualViewport gives one answer on
 * every runtime: header at the top of what is visible, input row just above
 * the keyboard.
 *
 * Writes two custom properties the CSS reads with fallbacks, so without
 * visualViewport (or once cleared) the sheet is the plain inset:0 box.
 *
 * Imported by ai_chat_controller.js and public_chat_controller.js.
 */

/** Size `element` to the visible area. Call on every visualViewport resize/scroll. */
export function pinToVisibleArea(element) {
    const area = window.visualViewport;
    if (!area) return;
    element.style.setProperty('--visible-top', `${area.offsetTop}px`);
    element.style.setProperty('--visible-height', `${area.height}px`);
}

/** Drop the pin so a closed or desktop sheet falls back to its stylesheet size. */
export function unpinVisibleArea(element) {
    element.style.removeProperty('--visible-top');
    element.style.removeProperty('--visible-height');
}
